/**
 * Local LLM admin API client (P3-S4 Doc 45).
 */
import { api } from "@/api/client";

export interface OllamaModelInfo {
  name: string;
  size_bytes: number | null;
  size_human: string | null;
  modified_at: string | null;
}

export interface LocalLLMStatus {
  ok: boolean;
  base_url: string;
  default_model: string;
  models: OllamaModelInfo[];
  on_prem_only: boolean;
  error: string | null;
}

export interface TestChatResponse {
  ok: boolean;
  text: string;
  error: string | null;
  model: string | null;
  duration_ms: number | null;
}

export const localLlmApi = {
  status: (): Promise<LocalLLMStatus> =>
    api.get<LocalLLMStatus>("/api/v1/admin/local-llm/status"),
  setOnPrem: (on_prem_only: boolean): Promise<LocalLLMStatus> =>
    api.post<LocalLLMStatus>("/api/v1/admin/local-llm/on-prem", {
      on_prem_only,
    }),
  testChat: (prompt: string, model?: string): Promise<TestChatResponse> =>
    api.post<TestChatResponse>("/api/v1/admin/local-llm/test", {
      prompt,
      model,
    }),
};
